import React from 'react'
import { FormFieldShell } from './FormFieldShell'
import {
  DateTimeFieldControl,
  type DateTimeFieldControlProps,
} from './dateTime/DateTimeFieldControl'
import type { BaseFormFieldProps } from './formFieldTypes'

export type DateInputProps = BaseFormFieldProps &
  Pick<DateTimeFieldControlProps, 'showIcon' | 'endText'> & {
    /** Chuỗi ngày `YYYY-MM-DD`. */
    value?: string
    onChange?: (event: { target: { value: string; name?: string } }) => void
    name?: string
  }

/**
 * Form field chỉ chọn ngày — cùng phong cách base `DateTimeInput`
 * (ô gõ `dd/MM/yyyy`, icon lịch, dropdown calendar, focus bôi đen cả ô).
 *
 * value/onChange: `YYYY-MM-DD`.
 * Ẩn icon: `showIcon={false}`.
 */
export function DateInput({
  label,
  labelAction,
  value = '',
  name,
  onChange,
  required,
  disabled,
  error,
  helperText,
  size,
  fullWidth,
  sx,
  id,
  surface,
  showIcon,
  endText,
}: DateInputProps) {
  const resolvedFullWidth = fullWidth === true
  // Chuẩn hoá về `YYYY-MM-DD` nếu caller còn truyền datetime.
  const dateValue = String(value ?? '').trim().slice(0, 10)

  const control = (
    <DateTimeFieldControl
      value={dateValue}
      onChange={(next) =>
        onChange?.({ target: { value: String(next ?? '').slice(0, 10), name } })
      }
      disabled={disabled}
      required={required}
      error={error}
      fullWidth={resolvedFullWidth}
      id={id}
      surface={surface}
      dateOnly
      showIcon={showIcon}
      endText={endText}
      sx={!label && !labelAction && !helperText ? sx : undefined}
    />
  )

  if (!label && !labelAction && !helperText) {
    return control
  }

  return (
    <FormFieldShell
      label={label}
      labelAction={labelAction}
      required={required}
      disabled={disabled}
      error={error}
      helperText={helperText}
      fullWidth={resolvedFullWidth}
      size={size}
      sx={sx}
      id={id}
      surface={surface}
    >
      {control}
    </FormFieldShell>
  )
}

export default DateInput
